module.exports = __webpack_public_path__ + "static/media/admin.1502c4f4.svg";